/*
 * @Author: your name
 * @Date: 2021-08-19 10:23:40
 * @LastEditTime: 2021-08-24 08:26:55
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\router\modules\settleRouter.js
 */
import cartLayout from '@/views/cart/index'
import topLayout from '@/views/layout/topLayout';

const settleRouter = [
    {
        path: '/cart',
        component: cartLayout,
        children: [
            {
                path: 'cartList',
                component: () => import('@/views/cart/cartList'),
                name: 'cartList',
                meta: { title: '购物车', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'copm',
                component: () => import('@/views/cart/copm'),
                name: 'copm',
                meta: { title: '商家列表', icon: '', affix: true, }
            },{
                path:'ruzhu',
                component:()=>import('@/views/cart/ruzhu'),
                name:'ruzhu',
                meta: { title: '商家入驻', icon: '', affix: true, }
            }
        ]
    },
    {
        path: '/settle',
        component: topLayout,
        children: [
            {
                path: 'index',
                component: () => import('@/views/settle/goodsSettle'),
                name: 'goodsSettle',
                meta: { title: '提交订单', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'monthPay',
                component: () => import('@/views/settle/payment'),
                name: 'monthPay',
                meta: { title: '提交订单', icon: '', affix: true, requireAuth: true }
            },
            {
                path: 'onlinePay',
                component: () => import('@/views/settle/payOrder'),
                name: 'onlinePay',
                meta: { title: '提交订单', icon: '', affix: true, requireAuth: true }
            }, {
                path: 'alipay',
                component: () => import('@/views/settle/alipay'),
                name: 'alipay',
                meta: { title: '提交订单', icon: '', affix: true, requireAuth: true }
            }
        ]
    }
]
export default settleRouter;


// WEBPACK FOOTER //
// ./src/router/modules/settleRouter.js